import * as React from 'react'
import { Box, Grid, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { DesktopMac } from '@material-ui/icons'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useDispatch, useSelector } from 'react-redux'
import { trackEvent } from '../../../helpers/analytics'
import DesktopWidgetsList from './DesktopWidgetsList'
import MobileWidgetsList from './MobileWidgetsList'

import {
  fetchDashboard,
  selectWidgets,
  selectWidgetCallStatus,
  fetchUserOrder,
} from '../dashboardSlice'
import { fetchMyAlerts, fetchPortalAlerts } from './MyAlerts/MyAlertsSlice'

/**
  WidgetsList is used to display all the widgets on the dashboard page depending on screen size
 */
function WidgetsList({ isAdmin }) {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('md'))
  const dispatch = useDispatch()
  const widgetCallState = useSelector(selectWidgetCallStatus)
  const apiReturnedWidgets = useSelector(selectWidgets)
  const adminWidgets = useSelector((s) => s.adminPage.widgets)
  const adminWidgetCallState = useSelector((s) => s.adminPage.status)

  // React.useEffect(() => {
  //   console.log('Getting following widgets')
  //   console.log(apiReturnedWidgets)
  // }, [apiReturnedWidgets])

  React.useEffect(() => {
    trackEvent(dispatch, {
      eventName: 'uxp_dashboard_view',
      module: 'Dashboard',
      object: 'Dashboard',
      action: 'View',
      actionContext: 'DashboardLoad',
      actionContextValue: 'DashboardOpened',
    })
    trackEvent(dispatch, {
      eventName: 'uxp_dashboard_entry',
      module: 'Dashboard',
      object: 'Dashboard',
      action: 'Entry',
      actionContext: 'DashboardLoad',
      actionContextValue: 'DashboardEntry',
    })
    const trackedScrollDepths = new Set()
    const scrollThresholds = [25, 50, 75, 100]
    const handleDashboardScroll = () => {
      const scrollTop = window.scrollY
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight
      if (docHeight <= 0) {
        return
      }
      const scrollpercent = (scrollTop / docHeight) * 100
      scrollThresholds.forEach((threshold) => {
        if (scrollpercent >= threshold && !trackedScrollDepths.has(threshold)) {
          trackedScrollDepths.add(threshold)
          trackEvent(dispatch, {
            eventName: 'uxp_dashboard_scroll',
            module: 'Dashboard',
            object: 'Dashboard',
            action: 'Scroll',
            actionContext: 'Dashboard',
            actionContextValue: `${threshold}Percent`,
          })
        }
      })
    }
    window.addEventListener('scroll', handleDashboardScroll)
    // TODO: Add Role param to change widgets returned based on role
    dispatch(fetchDashboard())
      .unwrap()
      .then(() => {
        if (
          localStorage.getItem('user') &&
          localStorage.getItem('user') !== '"visitor"'
        )
          dispatch(fetchMyAlerts()).then(() => {
            dispatch(fetchPortalAlerts())
          })
      })
    dispatch(fetchUserOrder())
    return () => {
      window.removeEventListener('scroll', handleDashboardScroll)
    }
  }, [])

  const AdminDisabledModeMessage = () => (
    <Grid
      container
      direction="column"
      alignItems="center"
      spacing={2}
      style={{ margin: 'auto' }}
    >
      <Grid item>
        <DesktopMac color="primary" fontSize="large" />
      </Grid>
      <Grid item>
        <Typography variant="h6" align="center">
          Admin Mode Is Not Available On Mobile.
        </Typography>
      </Grid>
    </Grid>
  )

  return (
    <Box>
      {matches ? (
        <DesktopWidgetsList
          isAdmin={isAdmin}
          widgetCallState={isAdmin ? adminWidgetCallState : widgetCallState}
          apiReturnedWidgets={isAdmin ? adminWidgets : apiReturnedWidgets}
        />
      ) : (
        <>
          {isAdmin ? (
            <AdminDisabledModeMessage />
          ) : (
            <MobileWidgetsList
              widgetCallState={widgetCallState}
              apiReturnedWidgets={apiReturnedWidgets}
            />
          )}
        </>
      )}
    </Box>
  )
}

export default WidgetsList
